<template>
  <div class="index">
    <div class="index-item">
      <div class="region">
        <div class="region-item">
          <div class="region-item-title">门店</div>
          <div class="region-item-line">
            <div class="region-item-line-title">手机号</div>
            <normal-input keyname="mobile" v-model="form.mobile" clearable :isShowIcon='false' placeholder="请输入您的手机号码"
              label="" type="" :rules="mobileRules" :isAutoFocus="true" update:modelValue="inputUpdate"
              @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line" v-show="isReApply">
            <div class="region-item-line-title">密码</div>
            <normal-input keyname="password" v-model="form.password" clearable :isShowIcon='false' placeholder="请输入登陆密码"
              label="" type="" :rules="passwordRules" :isAutoFocus="true" update:modelValue="inputUpdate"
              @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line" v-show="isReApply">
            <div class="region-item-line-title">验证码</div>
            <div class="code">
              <normal-input keyname="code" v-model="form.code" clearable :isShowIcon='false' placeholder="输入您收到的验证码"
                label="" type="" :rules="codeRules" :isAutoFocus="true" update:modelValue="inputUpdate"
                @dropDownValueChange="fruitValueChange">

                <div class="right-btn-wrapper">
                  <button v-if="!timerText" @click="sendCode">获取验证码</button>
                  <button v-else class="btn-disabled">{{ timerText }}</button>
                </div>
              </normal-input>
            </div>

          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">陈列等级</div>
            <div class="region-item-line-content" @click="showLevelPicker = true">
              <span style="font-size: 14px;">{{ form.levelName || '请选择陈列等级' }}</span>
              <img src="../../assets/icon/right.png" alt="">
            </div>
            <van-popup v-model="showLevelPicker" position="bottom">
              <van-picker show-toolbar title="选择陈列等级" value-key="name" :columns="levelList" @confirm="onConfirmLevel"
                @cancel="showLevelPicker = false" />
            </van-popup>
            <div v-if="!form.levelName" style="color: red; font-size: 12px;">请选择陈列等级</div>
          </div>

          <div class="region-item-line">
            <div class="region-item-line-title">店铺名称</div>
            <normal-input keyname="name" v-model="form.name" clearable :isShowIcon='false' placeholder="请输入您的店铺名称"
              label="" type="" :rules="nameRules" :isAutoFocus="true" update:modelValue="inputUpdate"
              @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">地区</div>
            <div class="region-item-line-content" @click="showArea = true">
              <span style="font-size: 14px;">{{ addArea || '请选择店铺所在省市县/区' }}</span>
            </div>
            <van-popup v-model="showArea" position="bottom">
              <van-area ref="area" value="110000" :area-list="areaList" @confirm="confirmArea"
                @cancel="showArea = false"></van-area>
            </van-popup>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">详细地址</div>
            <normal-input keyname="address" v-model="form.address" clearable :isShowIcon='false' placeholder="填写店铺详细地址"
              label="" type="" :rules="isEmptyRules" :isAutoFocus="true" update:modelValue="inputUpdate"
              @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">老板姓名</div>
            <normal-input keyname="boss_name" v-model="form.boss_name" clearable :isShowIcon='false'
              placeholder="输入店铺联系人姓名" label="" type="" :rules="nameRules" :isAutoFocus="true"
              update:modelValue="inputUpdate" @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">业务跟进</div>
            <normal-input keyname="follow_up" v-model="form.follow_up" clearable :isShowIcon='false'
              placeholder="请输入业务跟进人姓名" label="" type="" :rules="isEmptyRules" :isAutoFocus="true"
              update:modelValue="inputUpdate" @dropDownValueChange="fruitValueChange"></normal-input>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">经销商</div>
            <div class="search">
              <div class="search-input">
                <normal-input keyname="resellerSearch" v-model="resellerSearch" clearable :isShowIcon='false'
                  placeholder="搜索经销商" label="" type="" :rules="resellerSearch ? nameRules : []" :isAutoFocus="true"
                  update:modelValue="inputUpdate" @dropDownValueChange="fruitValueChange"></normal-input>
              </div>
              <button class="search-btn" @click="searchReseller">搜</button>
            </div>
            <div class="region-item-line-content" @click="showResellerPicker = true">
              <span style="font-size: 14px;">{{ form.resellerName || '请选择经销商' }}</span>
              <img src="../../assets/icon/right.png" alt="">
            </div>
            <van-popup v-model="showResellerPicker" position="bottom">
              <van-picker show-toolbar title="选择经销商" value-key="name" :columns="resellerList"
                @confirm="onConfirmReseller" @cancel="showResellerPicker = false" />
            </van-popup>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">业务员1</div>
            <div class="search">
              <div class="search-input">
                <normal-input keyname="salesmanSearch" v-model="salesmanSearch" clearable :isShowIcon='false'
                  placeholder="搜索业务员1" label="" type="" :rules="salesmanSearch ? nameRules : []" :isAutoFocus="true"
                  update:modelValue="inputUpdate" @dropDownValueChange="fruitValueChange"></normal-input>
              </div>
              <button class="search-btn" @click="searchSalesman">搜</button>
            </div>
            <div class="region-item-line-content" @click="showSalesmanPicker = true">
              <span>{{ form.salesmanName || '请选择业务员1' }}</span>
              <img src="../../assets/icon/right.png" alt="">
            </div>
            <van-popup v-model="showSalesmanPicker" position="bottom">
              <van-picker show-toolbar title="选择业务员1" value-key="name" :columns="salesmanList"
                @confirm="onConfirmSalesman" @cancel="showSalesmanPicker = false" />
            </van-popup>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">业务员2</div>
            <div class="search">
              <div class="search-input">
                <normal-input keyname="mobile" v-model="salesmanOtherSearch" clearable :isShowIcon='false'
                  placeholder="搜索业务员2" label="" type="" :rules="salesmanOtherSearch ? nameRules : []"
                  :isAutoFocus="true" update:modelValue="inputUpdate"
                  @dropDownValueChange="fruitValueChange"></normal-input>
              </div>
              <button class="search-btn" @click="searchSalesmanOther">搜</button>
            </div>
            <div class="region-item-line-content" @click="showSalesmanOtherPicker = true">
              <span>{{ form.salesmanOtherName || '请选择业务员2' }}</span>
              <img src="../../assets/icon/right.png" alt="">
            </div>
            <van-popup v-model="showSalesmanOtherPicker" position="bottom">
              <van-picker show-toolbar title="如有多个业务员，请选择业务员2" value-key="name" :columns="salesmanOtherList"
                @confirm="onConfirmSalesmanOther" @cancel="showSalesmanOtherPicker = false" />
            </van-popup>
          </div>
          <div class="region-item-line">
            <div class="region-item-line-title">店铺资质</div>
            <div class="image-wrapper">
              <label>
                <input type="file" accept="image/*" @change="uploadFile" id="license" capture="camera">
                <img v-if="licenseImg" :src="licenseImg + '?imageView2/1/w/165/h/90'">
                <img v-else src="../../assets/img/img_licence_upload.png">
              </label>
              <label>
                <input type="file" accept="image/*" @change="uploadFile" id="shopImg" capture="camera">
                <img v-if="shopImg" :src="shopImg + '?imageView2/1/w/165/h/90'">
                <img v-else src="../../assets/img/img_shop_photo_upload.png">
              </label>
            </div>
          </div>
          <p class="page-tips">注册代表您同意<span @click="showTreaty = true">《国花瓷盟友服务协议》</span></p>
          <van-popup v-model="showTreaty" closeable position="bottom" :style="{ height: '50%' }">
            <div class="treaty">
              <p class="treaty-title">国花瓷盟友服务协议</p>
              <p> 一、注册条款的接受</p>
              <p>
                请您认真阅读本协议尤其是免除或者限制本平台责任的条款及其它限制您权利的条款，一旦您注册即表示您已经阅读并且同意与本平台达成协议，完全理解并接受所有的注册条款。阅读本协议过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。
              </p>
              <br />
              <p>二 、用户注册条件</p>
              <p>1. 申请注册成为本平台的用户应同时满足下列全部条件：</p>
              <p>在注册之日必须年满18周岁以上。</p>
              <p>2. 为更好的享有本平台提供的服务，用户应：</p>
              <p>向本平台提供本人真实、正确、最新及完整的资料；</p>
              <p>随时更新登记资料，保持其真实性及有效性；</p>
              <p>提供真实有效的联系人手机号码；</p>
              <br />
              <p>三、用户账号名称安全</p>
              <p>任何注册和使用的本平台账号名称，不得有下列情形：</p>
              <p>1.违反宪法或法律法规规定的；</p>
              <p>2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
              <p>3.损害国家荣誉和利益的，损害公共利益的；</p>
              <p>4.煽动民族仇恨、民族歧视，破坏民族团结的；</p>
              <p>5.破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
            </div>
          </van-popup>
        </div>
      </div>
      <div class="index-btn">
        <button @click="rigister" :style="disabledValue ? '' : 'background: #f8dda1;'"
          :disabled='!disabledValue'>提交信息</button>
      </div>
    </div>

  </div>
</template>

<script>

import Vue from 'vue'
import qs from 'qs'
import Area from '@/util/area'
import NormalInput from '@/components/normalInput.vue'
import { Toast, AddressEdit, Picker, Popup, DatetimePicker } from 'vant'
import { mapGetters } from 'vuex'
import { getQiniuUpToken, uploadFile } from '@/util/qiniu'
Vue.use(Toast).use(AddressEdit).use(Picker).use(DatetimePicker)
  .use(Area).use(Popup)

export default {
  name: 'ShopRegister',
  data() {
    return {
      timerText: '',
      readMobile: false,
      areaList: Area,
      showArea: false, // 控制地区选择弹出和隐藏
      showDate: false, // 控制时间选择弹出和隐藏
      showTreaty: false, // 控制协议弹出和隐藏
      isReApply: true, // 是否是申请被拒后重新申请
      currentDate: new Date(2000, 0, 1),
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      addArea: '',
      id: '',
      licenseImg: '',
      shopImg: '',
      fileType: 0,
      resellerList: [],
      resellerSearch: '',
      showResellerPicker: false,
      salesmanList: [],
      salesmanSearch: '',
      showSalesmanPicker: false,
      salesmanOtherList: [],
      salesmanOtherSearch: '',
      showSalesmanOtherPicker: false,
      form: {
        mobile: '', mobileVerify: false, password: '', passwordVerify: false, code: '', codeVerify: false,
        name: '', nameVerify: false, boss_name: '', boss_nameVerify: false, follow_up: '', follow_upVerify: false,
        address: '', province: '', province_code: '',
        city: '', city_code: '', district: '', district_code: '', salesmanId: '', resellerCode: '',
        license: '', shopImage: [{ id: '', image: '' }], level: ''
      },
      nameRules: [
        { type: 'isSpecialChar', message: '不能包含特殊字符和表情，且长度不能超过32位' },
        { type: 'isNameLength', message: '长度必须保证在1~32位', min: 1, max: 32 },
        { type: 'isEmpty', message: '不能为空' }
      ],
      mobileRules: [
        { type: 'isPhoneNumber', message: '手机号格式不对' }
      ],
      codeRules: [{ type: 'isVerifyCode', message: '验证码格式不对' }],
      isEmptyRules: [{ type: 'isEmpty', message: '不能为空' }],
      passwordRules: [{ type: 'isPassword', message: '需要包含数字、字母等超过8个字符' }],
      disabled: false,

      showLevelPicker: false,
      levelList: [{ name: '无协议店', value: 0 },
        { name: '1A', value: 1 },
        { name: '2A', value: 2 },
        { name: '3A', value: 3 }]
    }
  },
  computed: {
    ...mapGetters(['shopOpenId', 'shopSubscribe', 'location']),
    disabledValue() {
      return (this.form.mobileVerify && this.form.passwordVerify &&
        this.form.codeVerify && this.form.nameVerify &&
        this.form.boss_nameVerify && this.form.follow_upVerify && this.form.address &&
        this.form.province && this.form.resellerCode && this.form.salesmanId && this.form.license && this.form.shopImage[0].image && this.form.levelName
      )
    }
  },
  components: {
    NormalInput
  },
  watch: {
    shopOpenId: function(value) {
      if (value && !this.$route.params.reapplyData) {
        if (!this.shopSubscribe) {
          return this.$router.push({ name: 'ShopSubscribe' })
        }
        this.verifyApply()
      }
    }
  },
  created() {
    this.getSalesmanList()
    this.getSalesmanOtherList()
    this.getResellerList()
    // 判断路由是否从被拒页面跳转来的，没有被拒，就正常流程执行注册
    // 保证店铺openid已存在
    if (!this.$route.params.reapplyData && this.shopOpenId) {
      if (!this.shopSubscribe) {
        return this.$router.push({ name: 'ShopSubscribe' })
      }
      // this.verifyApply()
    } else if (this.$route.params.reapplyData) {
      // 审核被拒后重新申请注册，注册页返回之前已填写的内容
      var _data = this.$route.params.reapplyData
      console.log(_data)
      this.form.mobile = _data.mobile
      this.readMobile = true
      this.form.name = _data.name
      this.form.boss_name = _data.boss_name
      this.form.province = _data.province
      this.form.city = _data.city
      this.form.district = _data.district
      this.form.license = _data.license
      this.form.shopImage[0] = _data.images[0]
      this.form.shopImage[0].image = this.form.shopImage[0].after_updated
      this.shopImg = this.form.shopImage[0].after_updated
      this.form.address = _data.address
      this.form.follow_up = _data.follow_up
      this.addArea = _data.province + _data.city + _data.district
      this.licenseImg = this.form.license
      this.shop = _data.shop
      this.form.province_code = _data.province_code
      this.form.city_code = _data.city_code
      this.form.district_code = _data.district_code
      this.form.resellerName = _data.reseller_name
      this.form.resellerCode = _data.reseller_code
      this.form.resellerMobile = _data.reseller_mobile
      this.form.salesmanName = _data.salesman_name
      this.form.salesmanId = _data.saleseman_id
      this.form.salesmanMobile = _data.salesman_mobile
      this.form.salesmanOtherName = _data.salesman_name_other
      this.form.salesmanOtherId = _data.saleseman_id_other
      this.form.salesmanOtherMobile = _data.saleseman_mobile_other
      this.form.level = _data.level
      this.isReApply = false
    }
  },
  methods: {
    fruitValueChange(e, keyname) {
      console.log(e, keyname)
      keyname = keyname + 'Verify'
      this.form[keyname] = e
      console.log(this.form)
      this.disabled = e
    },
    // 省市区选择器,地区选择确认
    confirmArea(value, index) {
      let areaName = ''
      for (var i = 0; i < value.length; i++) {
        areaName = areaName + value[i].name + ' '
      }
      this.addArea = areaName
      this.form.province = value[0].name
      this.showArea = false
      this.form.province = value[0].name
      this.form.city = value[1].name
      this.form.district = value[2].name
      this.form.province_code = value[0].code
      this.form.city_code = value[1].code
      this.form.district_code = value[2].code
      console.log(this.form.province, '-----------------')
    },
    // 生日日期选择
    onChangeDate() { },
    // 生日日期确认
    confirmDate(value) {
      this.showDate = false
      console.log(value)
      // 确认后格式化日期
      var date = value
      var m = date.getMonth() + 1
      var d = date.getDate()
      if (m >= 1 && m <= 9) {
        m = '0' + m
      }
      if (d >= 0 && d <= 9) {
        d = '0' + d
      }
      var timer = date.getFullYear() + '-' + m + '-' + d
      this.form.birthday = timer
      console.log(this.form.birthday)
    },
    // 注册
    rigister() {
      console.log(this.disabled, '----------')
      if (!this.form.mobile || !(/^1[3456789]\d{9}$/.test(this.form.mobile))) {
        return Toast('请输入正确的手机号')
      }
      if (this.isReApply) {
        if (!this.form.password || this.form.password.length < 6 || this.form.password.length > 12) {
          return Toast('请输入6~12个字符的密码')
        }
        if (!this.form.code) {
          return Toast('验证码不能为空')
        }
      }
      if (!this.form.name) {
        return Toast('店铺名不能为空')
      }
      if (!this.form.district) {
        return Toast('请选择店铺所在省市县/区')
      }
      if (!this.form.address) {
        return Toast('请填写店铺详细地址')
      }
      if (!this.form.boss_name) {
        return Toast('请填写老板姓名')
      }

      if (!this.form.license) {
        return Toast('请上传店铺营业执照图片')
      }
      if (!this.form.shopImage[0].image) {
        return Toast('请上传店铺门头图片')
      }

      if (!this.form.resellerCode) {
        return Toast('请选择所属经销商')
      }
      if (!this.form.salesmanId) {
        return Toast('请选择所属业务员1')
      }
      if (!this.form.levelName) {
        return Toast('请选择陈列等级')
      }
      console.log(this.location)
      var params = {
        mobile: this.form.mobile, name: this.form.name,
        password: this.form.password, code: this.form.code,
        openid: this.shopOpenId,
        province: this.form.province, city: this.form.city,
        district: this.form.district, province_code: this.form.province_code,
        city_code: this.form.city_code, district_code: this.form.district_code,
        boss_name: this.form.boss_name, follow_up: this.form.follow_up,
        address: this.form.address, license: this.form.license,
        reseller_code: this.form.resellerCode, reseller_name: this.form.resellerName,
        reseller_mobile: this.form.resellerMobile, salesman_id: this.form.salesmanId,
        salesman_name: this.form.salesmanName, salesman_mobile: this.form.salesmanMobile,
        salesman_name_other: this.form.salesmanOtherName, saleseman_id_other: this.form.salesmanOtherId,
        saleseman_mobile_other: this.form.salesmanOtherMobile,
        location: this.location ? this.location.address : '',
        longitude: this.location ? this.location.longitude : '',
        latitude: this.location ? this.location.latitude : '',
        level: this.form.level
      }
      console.log(params)
      const that = this
      // 正常提交申请，需要判断路由是否从被拒页面跳转reapplyData是从被拒的审核页面传过来的
      if (!this.$route.params.reapplyData) {
        params.shopImage = this.form.shopImage[0].image
        this.axios.post('/shop/register/', qs.stringify(params)).then(function(res) {
          if (res.code === 0) {
            Toast('账号注册申请成功')
            that.$router.push({ name: 'ShopVerify' })
          } else {
            Toast(res.message)
          }
        }).catch(function(error) {
          console.log(error)
          Toast('注册失败')
        })
      } else {
        // 审核被拒，重新修改提交申请
        params.images = this.form.shopImage
        var url = 'shop/' + this.shop + '/'
        var headers = { 'content-type': 'application/json' }
        this.axios.put(url, params, { headers: headers }).then(function(res) {
          if (res.code === 0) {
            Toast('资料重新申请成功')
            that.$router.push({ name: 'ShopVerify' })
          } else {
            Toast(res.message)
          }
        }).catch(function(error) {
          console.log(error)
          Toast('注册失败')
        })
      }
    },
    // 发送短信验证码
    sendCode() {
      console.log(this.form)
      if (!this.form.mobile || !(/^1[3456789]\d{9}$/.test(this.form.mobile))) {
        return Toast('请输入正确的手机号')
      }
      var that = this
      var params = { mobile: this.form.mobile, type: 1 }
      this.axios.post('/system/sms/verify_mobile/', qs.stringify(params)).then(function(res) {
        if (res.code === 0) {
          Toast('发送成功')
          that.timerText = '60s后重新发送'
          let total = 60
          var clock = window.setInterval(() => {
            total--
            that.timerText = total + 's后重新发送'
            if (!total) {
              total = 60
              that.timerText = ''
              clearInterval(clock)
            }
          }, 1000)
        } else {
          Toast(res.message)
        }
      }).catch(function(error) {
        console.log(error)
        Toast('发送失败')
      })
    },
    // 图片上传
    async uploadFile(img) {
      const res = await getQiniuUpToken(this.fileType)
      console.log(res)
      const that = this

      uploadFile(img.target.files[0], res.key, res.token, function(err) {
        if (err) {
          Toast('上传失败')
        }
        if (img.target.id === 'license') {
          that.licenseImg = res.url
          that.form.license = res.url
          console.log(that.form.license, '--------------0000---')
        } else if (img.target.id === 'shopImg') {
          that.shopImg = res.url
          that.form.shopImage[0].image = res.url
        }
      })
    },
    // 展示国花瓷服务协议
    shopTips() {
    },
    // create里根据openid判断店铺注册状态，已注册就跳转到审核页面
    verifyApply() {
      var params = { openid: this.shopOpenId }
      const that = this
      this.axios.post('/shop/check_register/', qs.stringify(params))
        .then(function(res) {
          console.log(res)
          if (res.code === 5000) {
            console.log(res.message)
          } else {
            var status = res.data.status
            var rejectData = res.data
            console.log('注册页面')
            if (status === 0) {
              console.log('待审核')
              console.log(status)
              Toast('你已提交注册申请')
              that.$router.push({ name: 'ShopVerify', params: { status: status }})
            } else if (status === 1) {
              console.log('审核通过')
              that.$router.push({ name: 'ShopVerify', params: { status: status }})
            } else if (status === 2) {
              Toast('审核被拒')
              that.$router.push({ name: 'ShopVerify', params: { status: status, rejectData: rejectData }})
            } else if (status === 3) {
              Toast('已禁用')
            }
          }
        })
    },
    // 选择陈列等级
    onConfirmLevel(obj) {
      console.log(obj)
      this.form.levelName = obj.name
      this.form.level = obj.value
      this.showLevelPicker = false
    },
    searchReseller() {
      const that = this
      // const params = { page: 1, size: 1000, search: this.resellerSearch }
      this.axios.get(`reseller/all/?search=${this.resellerSearch}`).then(res => {
        that.resellerList = res.data
        this.showResellerPicker = true
      })
    },
    // 获取经销商表
    getResellerList() {
      const that = this
      // const params = { page: 1, size: 1000 }
      this.axios.get(`/reseller/all/`).then(function(res) {
        console.log(res)
        that.resellerList = res.data
      })
    },
    // 选中经销商
    onConfirmReseller(obj) {
      console.log(obj)
      this.form.resellerName = obj.name
      this.form.resellerCode = obj.code
      this.form.resellerMobile = obj.mobile

      console.log(this.form.resellerName, this.form.resellerCode, this.form.resellerMobile, '==========')
      this.showResellerPicker = false
    },
    // 搜索业务员
    searchSalesman() {
      const that = this
      this.axios.get(`/salesman/?page=1&size=1000000&search=${this.salesmanSearch}`).then(res => {
        that.salesmanList = res.data.records
        this.showSalesmanPicker = true
      })
    },
    // 获取业务员列表
    getSalesmanList() {
      const that = this
      this.axios.get('/salesman/?page=1&size=100000').then(function(res) {
        console.log(res)
        that.salesmanList = res.data.records
      })
    },
    onConfirmSalesman(obj) {
      console.log(obj)
      this.form.salesmanName = obj.name
      this.form.salesmanId = obj.id
      this.form.salesmanMobile = obj.mobile
      this.showSalesmanPicker = false
    },
    // 搜索业务员
    searchSalesmanOther() {
      const that = this
      this.axios.get(`/salesman/?page=1&size=1000000&search=${this.salesmanOtherSearch}`).then(res => {
        that.salesmanOtherList = res.data.records
        this.showSalesmanOtherPicker = true
      })
    },
    // 获取业务员列表
    getSalesmanOtherList() {
      const that = this
      this.axios.get('/salesman/?page=1&size=100000').then(function(res) {
        console.log(res)
        that.salesmanOtherList = res.data.records
      })
    },
    onConfirmSalesmanOther(obj) {
      console.log(obj)
      this.form.salesmanOtherName = obj.name
      this.form.salesmanOtherId = obj.id
      this.form.salesmanOtherMobile = obj.mobile
      this.showSalesmanOtherPicker = false
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  background: #F6F8FA;
  height: 233px;
  background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);

  &-item {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .region {
    // position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 100px;

    &-item {
      background: #ffffff;
      border-radius: 16px;
      padding: 16px;
      margin-top: 16px;

      &-title {
        font-size: 16px;
        font-weight: bold;
        color: #111827;
      }

      &-line {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .image-wrapper {
          position: relative;
          // top: -20px;
          top: 0;
          display: flex;
          justify-content: space-between;
          padding: 0 5px;
          box-sizing: border-box;

          img {
            width: 150px;
            height: 90px;
          }

          input {
            position: absolute;
            opacity: 0;
            padding: 0;
            // width: 165px;
            // height: 90px;
          }
        }

        .search {
          display: flex;
          justify-content: space-between;
          flex: 1;
          width: 100%;

          &-input {
            flex: 1;
          }

          &-select {}

          &-btn {
            margin-left: 15px;
            background: #FAC859;
            border-radius: 12px;
            width: 48px;
            height: 48px;
            border-style: none;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
          }

        }

        &.row {
          flex-direction: row;
          justify-content: space-between;
        }

        &-title {
          margin-top: 16px;
          font-size: 14px;
          font-weight: bold;
          color: #111827;
        }

        &-tips {
          font-size: 12px;
          font-weight: 400;
          color: #A0AEC0;
        }

        &-content {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 14px 16px;
          background: #f6f8fa;
          border-radius: 12px;

          span {
            font-size: 14px;
            color: #8b97a6;
            font-weight: 400;
          }

          input {
            flex: 1;
            font-size: 14px;
          }

          img {
            width: 16px;
            height: 16px;
            transform: rotate(90deg);
          }
        }

        &-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 48px;
          height: 48px;
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          background: #0caf60;
          box-shadow: 0px 4px 8px 0px rgba(0, 88, 45, 0.2);
          border-radius: 12px;
        }
      }
    }



  }

  &-btn {
    position: fixed;
    bottom: 35px;
    left: 0;
    right: 0;
    padding-bottom: 20px;
    margin-left: 15px;
    margin-right: 15px;

    button {
      width: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 15px;
      background: #FAC859;
      box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
      border-radius: 12px;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      border-style: none;
      font-style: normal;
    }
  }



}


/deep/ .login-input {
  font-size: 14px !important;
  color: #111827 !important;
  background: #F6F8FA !important;
  border-radius: 12px;
  z-index: 0;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  border: none !important;

  .login-input-inp {
    // width: 100%;
  }

  input {
    background-color: transparent !important;
  }
}

.code {
  /deep/ .login-input {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .login-input-inp {
      width: 60%;
    }
  }

  .right-btn-wrapper {
    button {
      padding: 10px 7px;
      background: #FAC859;
      border-radius: 7px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 17px;
      text-align: right;
      font-style: normal;
      border-style: none;
    }
  }
}




.shop-register-container {
  overflow: scroll;

  .main-wrapper {
    margin: 15px 0 60px;

    .input-item {
      position: relative;
      height: 45px;
      padding: 0 10px;
      background-color: #fff;
      margin-bottom: 1px;
      line-height: 45px;
      font-size: 14px;
      color: #000;

      span {
        width: 60px;
        font-weight: 400;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
      }

      input {
        width: 180px;
        text-align: left;
        height: 45px;
        vertical-align: top;
        padding: 0 5px;
      }

      .right-btn-wrapper {
        position: absolute;
        top: 0;
        right: 18px;
        height: 45px;

        button {
          width: 100px;
          height: 30px;
          background: #003485;
          color: #fff;
          font-size: 14px;
          border: none;
          border-radius: 15px;
        }
      }

      .image-wrapper {
        width: 100%;
        position: relative;
        // top: -20px;
        top: 0;
        display: flex;
        justify-content: space-between;
        padding: 0 5px;
        box-sizing: border-box;

        img {
          width: 165px;
          height: 90px;
        }

        input {
          position: absolute;
          opacity: 0;
          padding: 0;
          // width: 165px;
          // height: 90px;
        }
      }
    }

    .image-input {
      height: auto;
    }
  }

  .search-item {
    display: flex;
    align-items: center;
    gap: 5px;
    height: 90px;
    padding: 0 10px;
    margin-bottom: 1px;
    font-size: 14px;
    color: #000;
    background-color: #fff;

    span {
      width: 60px;
      font-weight: 400;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
    }

    input {
      width: 187.5px;
      text-align: left;
      height: 45px;
      vertical-align: top;
      padding: 0 5px;
    }

    .col {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
  }

  .footer-wrapper {
    position: fixed;
    bottom: 0;
    width: 375px;
    height: 60px;
    background: #fff;
    z-index: 10;

    .footer-btn {
      width: 345px;
      height: 40px;
      margin: 10px 20px;
      background: #003485;
      color: #fff;
      font-size: 14px;
      border: none;
      border-radius: 20px;
    }
  }
}

.arrow ::after {
  content: '';
  display: block;
  position: absolute;
  right: 20px;
  top: 10px;
  width: 20px;
  height: 30px;
  background-image: url("../../assets/icon/right.png");
  background-repeat: no-repeat;
  background-size: 30px;
  background-position: 0 0
}

.search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 70vw;
  height: 45px;
}

.search .text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  color: #ffffff;
  background-color: #003485;
  border-radius: 5px;
  font-size: 12px;
}

.search img {
  width: 20px;
  height: 20px;
}

.page-tips {
  margin: 0 0;
  padding: 10px 0;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #747474;
  letter-spacing: -0.35px;

  span {
    color: #4A90E2;
  }
}

.treaty {
  padding: 16px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  letter-spacing: -0.35px;
  color: #000;

  &-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shop/register.vue